import React, { useMemo } from "react";
import useClx from "../../hooks/use-clx";
import Modal, { useShowModal } from "../../hooks/use-modal";
import CouponSuggestion from "../CouponSuggestion";
import clxs from "./coupon-code.module.css";
import useValidateCoupons from "../../hooks/use-validate-coupon";
import useClusterValidateCoupons from "../../hooks/use-cluster-validate-coupon";
import CLOSE_ICON from "../../assets/icons/close.svg";
interface CouponCodeProps {
  value: string;
  propertySlug: string,
  configs?: PropertyConfigArg[];
  checkinDate?: string,
  checkoutDate?: string,
  adultCount?: number,
  childCount?: number,
  className?: string;
  onChange: (couponCode: string) => void;
  isCluster?: boolean;
  offering_type_ids?: string;
}

function CouponCode(props: CouponCodeProps) {
  const showCouponCodeSuggestions = useShowModal(COUPON_CODE_MODAL_ID),
    { propertySlug, value ,configs, checkinDate,checkoutDate,onChange, className, isCluster ,offering_type_ids,...suggestionProps } = props,
    /**
     * Hook to validate the coupon based on property and dates
     */
    { coupon } = isCluster 
    ? useClusterValidateCoupons(
      value,
      offering_type_ids ? offering_type_ids : "",
      propertySlug ? propertySlug : "",
      checkinDate ? checkinDate : "",
      checkoutDate ? checkoutDate : "",
    )
    : useValidateCoupons(
      value,
      configs? configs : [],
      propertySlug ? propertySlug : "",
      checkinDate ? checkinDate : "",
      checkoutDate ? checkoutDate : "",
    ),
    { title, applied, actionText } = useMemo(
      () => {
        const applied = coupon !== null;

        return {
          applied: applied,
          title: applied ?
            "Promocode Applied!" :
            "Have a discount coupon?",
          actionText: applied ? (
            <img
              className={clxs.closeIcon}
              src={CLOSE_ICON}
              alt="close-icon"
            />
          ) : "View Offers",
        }
      },
      [coupon],
    ),
    ccx = useClx(clxs.container, className),
    acx = applied ? clxs.remove : clxs.viewOffer,
    handleViewOffer = async () => {
      const couponCode = await showCouponCodeSuggestions(suggestionProps as any);

      if (!couponCode) {
        return;
      }

      onChange(couponCode || "");
    },
    handler = applied ? onChange.bind(null, "NONE") : handleViewOffer,
    discountValue = useMemo(() => {
      switch (coupon?.offer_type) {
          case "free_night":
              return `${coupon.code}(${coupon.offer_value} Night Free)`;
          case "percentage_discount":
              return `${coupon.code}(${coupon.offer_value}%)`;
          case "flat_discount":
              return `${coupon.code}(${coupon.offer_value?.toLocaleString("en-IN")} OFF)`;
          default:
              return `${coupon?.code}`;
      }
     }, [coupon]);

  return (
    <>
      <div className={ccx}>
        <div className={clxs.title}>
          {coupon && (
            <div className={clxs.success}>
              {discountValue}
            </div>
          )}
          <div 
            className={clxs.response}
            data-applied={applied}
          >{title}</div>
        </div>
        <button
          type="button"
          className={acx}
          onClick={handler}
        >
          {actionText}
        </button>
      </div>
      <Modal id={COUPON_CODE_MODAL_ID}>
        <CouponSuggestion 
          propertySlug={propertySlug}
          checkinDate={checkinDate}
          checkoutDate={checkoutDate}
          adultCount={suggestionProps.adultCount}
          childCount={suggestionProps.childCount}
          configs ={configs} //Configs was needed in checkout page.
          isCluster={isCluster}
          offering_type_ids={offering_type_ids}
        />
      </Modal>
    </>
  );
}

export default CouponCode;

const COUPON_CODE_MODAL_ID = "coupon-suggestions";